import React, { Suspense, lazy } from 'react';

// Lazy-loaded so the three.js/@react-three/fiber bundle is only fetched
// when this app is actually opened, not on initial OS-mode load.
const RunnerGame = lazy(() => import('../arcade/RunnerGame'));

const ArcadeApp = () => (
	<div className="h-full w-full bg-black">
		<Suspense
			fallback={
				<div className="h-full w-full flex items-center justify-center bg-black text-os-textdim font-os text-sm">
					Loading game…
				</div>
			}
		>
			<RunnerGame />
		</Suspense>
	</div>
);

export default ArcadeApp;
